import { http, queryString } from 'utils'
import { map, concat, findIndex } from 'lodash'

// Commodity mutation imports.
import { SET_COMMODITIES, ADD_COMMODITY, REPLACE_COMMODITY } from 'vx/mutations'

// Commodity state.
const state = {
  commodities: []
}

// Commodity state getters.
const getters = {
  /**
   * Commodity options with "All" option prefixed.
   */
  commodityOptionsWithAll (state, getters) {
    return concat([{ id: 'all', text: 'All' }], getters.commodityOptions)
  },

  /**
   * Commodity options for selectize.
   */
  commodityOptions (state) {
    return map(state.commodities, commodity => ({ id: commodity.id, text: commodity.name }))
  }
}

// Commodity actions.
const actions = {
  /**
   * Get a list of commodities.
   */
  getCommodities ({ commit }, payload) {
    return http.get(`commodities?${queryString(payload)}`).then(response => {
      commit(SET_COMMODITIES, response.data)

      return response
    })
  },

  /**
   * Store a new commodity.
   */
  storeCommodity ({ commit }, payload) {
    return http.post(`commodities`, payload).then(response => {
      commit(ADD_COMMODITY, response.data)

      return response
    })
  },

  /**
   * Update an existing commodity.
   */
  updateCommodity ({ commit }, { id, payload }) {
    return http.put(`commodities/${id}`, payload).then(response => {
      commit(REPLACE_COMMODITY, response.data)

      return response
    })
  },

  /**
   * Archive (soft delete) an existing commodity.
   */
  archiveCommodity ({ commit }, id) {
    return http.delete(`commodities/${id}`).then(response => {
      return response
    })
  }
}

// Commodity state mutations.
const mutations = {
  /**
   * Set the commodities.
   */
  [SET_COMMODITIES] (state, commodities) {
    state.commodities = commodities
  },

  /**
   * Add commodity to the commodities array.
   */
  [ADD_COMMODITY] (state, commodity) {
    state.commodities.unshift(commodity)
  },

  /**
   * Replace commodity in array with update commodity.
   */
  [REPLACE_COMMODITY] (state, commodity) {
    state.commodities.splice(findIndex(state.commodities, existing => existing.id === commodity.id), 1, commodity)
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/commodity.js